module.exports = __webpack_public_path__ + "img/dy_top.24d2067c.png";